var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaperJet = function SvgPaperJet(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 48,
    viewBox: "0 0 75 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9598 3.41695C71.7646 18.2715 68.5646 33.1212 65.3694 47.971C57.8624 44.9933 50.3601 42.0108 42.8531 39.0331C39.9479 41.7304 37.0428 44.4229 34.1376 47.1202C30.9424 42.0011 27.7472 36.8917 24.552 31.7726H24.5471C17.8329 29.1043 11.1186 26.4408 4.4043 23.7773C27.9212 16.9905 51.4429 10.2037 74.9598 3.41695Z",
    fill: "#FFE58F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5956 1C54.793 10.4503 37.9855 19.9005 21.1829 29.3508C14.4686 26.6873 7.75432 24.0238 1.04004 21.3604C24.5569 14.5736 48.0787 7.78679 71.5956 1Z",
    stroke: "#231F20",
    strokeWidth: 1.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5955 1C68.4003 15.8546 65.2003 30.7043 62.0051 45.554C54.498 42.5763 46.9958 39.5938 39.4888 36.6161C37.2604 35.7315 35.0368 34.8469 32.8083 33.9672C45.739 22.9797 58.6697 11.9923 71.5955 1Z",
    stroke: "#231F20",
    strokeWidth: 1.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5956 1C58.6697 11.9923 45.7391 22.9797 32.8084 33.9672C32.1316 37.5443 31.4549 41.1213 30.7733 44.6984C27.5781 39.5842 24.3829 34.4747 21.1877 29.3556H21.1829C37.9855 19.9005 54.7929 10.4503 71.5956 1Z",
    stroke: "#231F20",
    strokeWidth: 1.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7732 44.6984L39.4839 36.6161",
    stroke: "#231F20",
    strokeWidth: 1.74,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaperJet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "paper-jet.6c59c84182310a55a0f434156c50de81.svg";